import React from "react";
import css from "./index.module.scss";
import { useInView, animated } from "@react-spring/web";
import { useTranslation } from "react-i18next";

function Index() {
  const { t } = useTranslation();

  const [firtstRef, firstRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [secondRef, secondRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
      config: { duration: 500 },
    }),
    { threshold: 0.3, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [thirdRef, thirdRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );
  const [fourthRef, fourthRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.1, once: true } //只执行一次，threshold为阈值，0.5表示元素可见一半时触发,1表示完全可见时触发
  );

  return (
    <div className={css.upaycontain}>
      <div className={css.maintitle}>UPAY</div>

      <div className={css.first} ref={firtstRef}>
        <animated.div className={css.inner} style={firstRefStyle}>
          <div className={`${css.subtitle} ${css.none}`}>{t("产品介绍")}</div>
          <div className={`${css.secondtitle} ${css.none}`}>
            {t("$singlee_upay1")}
          </div>
          <div className={css.boxzone}>
            <div className={css.box}>
              <div className={css.title}>{t("$singlee_upay2")}</div>
              <div className={css.text}>
                {t("$singlee_upay3")}
                <br />
                {t("$singlee_upay4")}
                <br />
                {t("$singlee_upay5")}
              </div>
              <div className={css.icon}>
                <div className={css.t1}></div>
              </div>
            </div>
            <div className={css.box}>
              <div className={css.title}>{t("$singlee_upay6")}</div>
              <div className={css.text}>
                {t("$singlee_upay7")}
                <br />
                {t("$singlee_upay8")}
              </div>
              <div className={css.icon}>
                <div className={css.t2}></div>
              </div>
            </div>
            <div className={css.box}>
              <div className={css.title}>{t("$singlee_upay9")}</div>
              <div className={css.text}>
                {t("$singlee_upay10")}
                <br />
                {t("$singlee_upay11")}
              </div>
              <div className={css.icon}>
                <div className={css.t3}></div>
              </div>
            </div>
          </div>
        </animated.div>
      </div>

      <div className={css.second} ref={secondRef}>
        <animated.div className={css.inner} style={secondRefStyle}>
          <div className={css.subtitle}>{t("适用场景")}</div>
          <div className={css.content}>
            <div className={css.left}>
              <div className={css.text}>
                <div className={css.title}>{t("$singlee_upay12")}</div>
                {t("$singlee_upay13")}
                <br />
                {t("$singlee_upay14")}
              </div>
            </div>
            <div className={css.right}>
              <div className={css.title}>{t("$singlee_upay12")}</div>
              <div className={css.text}>
                {t("$singlee_upay13")}
                <br />
                {t("$singlee_upay14")}
              </div>
            </div>
          </div>
        </animated.div>
      </div>

      <div className={css.third} ref={thirdRef}>
        <animated.div className={css.inner} style={thirdRefStyle}>
          <div className={css.subtitle}>{t("部分合作案例")}</div>
          <div className={css.secondtitle}>{t("$singlee_upay15")}</div>
          <div className={css.contentbox}>
            <div className={css.grid}>
              <div className={css.item}>
                <div className={css.picbox}>
                  <img
                    src={require("assets/upay/m1.png")}
                    alt=""
                    style={{ maxWidth: "90px" }}
                  />
                </div>
                <div className={css.desc}>
                  {t("首旅如家集团")}
                  <br />
                  {t("$singlee_upay16")}
                </div>
              </div>
              <div className={css.item}>
                <div className={css.picbox}>
                  <img src={require("assets/upay/m2.png")} alt="" />
                </div>
                <div className={css.desc}>
                  {t("浙江十足")}
                  <br />
                  {t("$singlee_upay17")}
                </div>
              </div>
              <div className={css.item}>
                <div className={css.picbox}>
                  <img src={require("assets/upay/m3.png")} alt="" />
                </div>
                <div className={css.desc}>
                  {t("$singlee_upay18")}
                  <br />
                  {t("$singlee_upay19")}
                </div>
              </div>
              <div className={css.item}>
                <div className={css.picbox}>
                  <img src={require("assets/upay/m4.png")} alt="" />
                </div>
                <div className={css.desc}>
                  {t("$singlee_pay24")}
                  <br />
                  {t("$singlee_upay20")}
                </div>
              </div>
            </div>
            <div className={css.pc}></div>
          </div>
        </animated.div>
      </div>

      <div className={css.fourth} ref={fourthRef}>
        <div className={css.inner} style={fourthRefStyle}>
          <div className={css.subtitle}>{t("各行各业合作伙伴")}</div>
          <animated.div className={css.box} style={fourthRefStyle}>
            <div className={css.boxitem}>
              <div className={`${css.picbox} ${css.one}`}></div>
              <div className={css.right}>
                <div className={css.content}>
                  <div className={css.title}>{t("$singlee_upay21")}</div>
                  {t("$singlee_upay22")}
                </div>
              </div>
            </div>
            <div className={css.boxitem}>
              <div className={`${css.picbox} ${css.two}`}></div>
              <div className={css.right}>
                <div className={css.content}>
                  <div className={css.title}>{t("$singlee_upay23")}</div>
                  {t("$singlee_upay24")}
                </div>
              </div>
            </div>
            <div className={css.boxitem}>
              <div className={`${css.picbox} ${css.three}`}></div>
              <div className={css.right}>
                <div className={css.content}>
                  <div className={css.title}>{t("$singlee_upay25")}</div>
                  {t("$singlee_upay26")}
                </div>
              </div>
            </div>
            <div className={css.boxitem}>
              <div className={`${css.picbox} ${css.four}`}></div>
              <div className={css.right}>
                <div className={css.content}>
                  <div className={css.title}>{t("$singlee_upay27")}</div>
                  {t("$singlee_upay28")}
                </div>
              </div>
            </div>
            <div className={css.boxitem}>
              <div className={`${css.picbox} ${css.five}`}></div>
              <div className={css.right}>
                <div className={css.content}>
                  <div className={css.title}>{t("$singlee_upay29")}</div>
                  {t("$singlee_upay30")}
                </div>
              </div>
            </div>
            <div className={css.boxitem}>
              <div className={`${css.picbox} ${css.six}`}></div>
              <div className={css.right}>
                <div className={css.content}>
                  <div className={css.title}>{t("$singlee_upay31")}</div>
                  {t("$singlee_upay32")}
                </div>
              </div>
            </div>
            <div className={css.boxitem}>
              <div className={`${css.picbox} ${css.seven}`}></div>
              <div className={css.right}>
                <div className={css.content}>
                  <div className={css.title}>{t("$singlee_upay33")}</div>
                  {t("$singlee_upay34")}
                </div>
              </div>
            </div>
            <div className={css.boxitem}>
              <div className={`${css.picbox} ${css.eight}`}></div>
              <div className={css.right}>
                <div className={css.content}>
                  <div className={css.title}>{t("$singlee_upay35")}</div>
                  {t("$singlee_upay36")}
                </div>
              </div>
            </div>
          </animated.div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Index);
